import { Icon, type IconName } from "@design-system/Icon";
import { FlexRow } from "@design-system/Layout/Flex";
import { type textColor } from "@design-system/Theme";
import { Ellipsis } from "@design-system/Typography/Ellipsis";
import { Text } from "@design-system/Typography/Text";
import { useMemo, type FC } from "react";
import { type Question as QuestionType } from "./types";

export const Question: FC<{
    question: QuestionType;
}> = ({ question }) => {
    const style: {
        icon: {
            iconName: IconName;
            className: string;
        };
        text: {
            color: keyof typeof textColor;
        };
    } = useMemo(() => {
        const { aiSuggestion } = question.answer ?? {};

        if (aiSuggestion?.isGenerating) {
            return {
                icon: {
                    iconName: "loader",
                    className: "text-accent-1-400 animate-spin",
                },
                text: {
                    color: "secondary",
                },
            };
        }

        if (aiSuggestion?.success) {
            return {
                icon: {
                    iconName: "circleValidated",
                    className: "[&>path:first-child]:fill-accent-1-400",
                },
                text: {
                    color: "primary",
                },
            };
        }

        if (aiSuggestion?.success === false) {
            return {
                icon: {
                    iconName: "warning",
                    className: "text-warning-600",
                },
                text: {
                    color: "primary",
                },
            };
        }
        return {
            icon: {
                iconName: "minus",
                className: "",
            },
            text: {
                color: "secondary",
            },
        };
    }, [question]);

    return (
        <FlexRow gap="4" alignItems="center" justifyContent="between">
            <Ellipsis asChild>
                <Text color={style.text.color}>{question.name}</Text>
            </Ellipsis>
            <Icon name={style.icon.iconName} className={style.icon.className} />
        </FlexRow>
    );
};
